__turbopack_context__.v({
  "contentItem": "GridList-module__m-URza__contentItem",
  "first": "GridList-module__m-URza__first",
  "headerSpacing": "GridList-module__m-URza__headerSpacing",
  "root": "GridList-module__m-URza__root",
});
